import { render, staticRenderFns } from "./ParticipantConsentRejectedConfirm.vue?vue&type=template&id=67a2ecf0&scoped=true&"
import script from "./ParticipantConsentRejectedConfirm.vue?vue&type=script&lang=ts&"
export * from "./ParticipantConsentRejectedConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipantConsentRejectedConfirm.vue?vue&type=style&index=0&id=67a2ecf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a2ecf0",
  null
  
)

export default component.exports